import React from "react";
import { Spin } from "antd";
export interface LoadingProps {
  className?: string;
  spinSize?: "small" | "default" | "large";
  spinTip?: string;
};

const Loading = (props: LoadingProps) : JSX.Element => {
  const { className, spinSize, spinTip } = props;

  return (
    <div className={`child-center ${className}`}>
      <Spin tip={spinTip} size={spinSize} />
    </div>
  );
}

Loading.defaultProps = {
  className: "",
  spinSize: "large",
  spinTip: "Učitavam..."
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.tsx